var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Close"},React.createElement("path",{"style":{"fillRule":"evenodd","clipRule":"evenodd"},"d":"M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312\r\n\t\tc-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312\r\n\t\tl75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937\r\n\t\tc6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z"})));
}

Cross.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 212.982 212.982","style":{"enableBackground":"new 0 0 212.982 212.982"},"xmlSpace":"preserve"};

module.exports = Cross;

Cross.default = Cross;
